// Leo's design, exactly (canvas "Floxir: proposed app structure"). Used by the redesigned header and Home only.
export const L = {
  bg: '#F4EFE7',
  card: '#FFFFFF',
  border: '#E3D9C8',
  rowLine: '#EFE7DA',
  text: '#2E2116',
  muted: '#6B5A4A',
  accent: '#A34A1B',
  accentHover: '#7A3A12',
  chipBg: '#FBF8F3',
  iconBg: '#FBEFEA',
  green: '#3F6424',
  sans: "'Source Sans 3', 'Helvetica Neue', sans-serif",
  serif: 'Spectral, Georgia, serif',
  brand: "'Playfair Display', Spectral, Georgia, serif",
};
